import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccesoComponent } from "./ui/components/pages/acceso/acceso.component";
import { AjusteSolicitudServiciosComponent } from "./ui/components/pages/ajuste-solicitud-servicios/ajuste-solicitud-servicios.component";
import { AprobacionServicioDirectivoComponent } from "./ui/components/pages/aprobacion-servicio-directivo/aprobacion-servicio-directivo.component";
import { GestionSolicitudProgramadorComponent } from "./ui/components/pages/gestion-solicitud-programador/gestion-solicitud-programador.component";
import { PagesSolicitudServicioComponent } from "./ui/components/pages/pages-solicitud-servicio/pages-solicitud-servicio.component";
import { CardReferenteComponent } from "./ui/components/pages/card-referente/card-referente.component";
import { CardProgramadorComponent } from "./ui/components/pages/card-programador/card-programador.component";
import { CardDirectivoComponent } from "./ui/components/pages/card-directivo/card-directivo.component";
import { SeguimientoSolicitudesServicioComponent } from "./ui/components/pages/seguimiento-solicitudes-servicio/seguimiento-solicitudes-servicio.component";
import { BandejaProgramadorComponent } from "./ui/components/pages/bandeja-programador/bandeja-programador.component";
import { InformesSolicitudesServicioComponent } from "./ui/components/pages/informes-solicitudes-servicio/informes-solicitudes-servicio.component";
import { EncuestaSatisfaccionComponent } from "./ui/components/pages/encuesta-satisfaccion/encuesta-satisfaccion.component";


const routes: Routes = [
  // modulo1
  { path: "", redirectTo: "Acceso", pathMatch: "full" },
  
  { 
    path: "Acceso",
    component: AccesoComponent
  },

  {
    path: "ajuste-solicitud/:id",
    component: AjusteSolicitudServiciosComponent,
  },

  { 
    path: "create-solicitud-servicio",
    component: PagesSolicitudServicioComponent 
  },

  { path: "card_directivo", component: CardDirectivoComponent },
  
  { path: "card_programador", component: CardProgramadorComponent },
  
  { path: "card_referente", component: CardReferenteComponent },

  {
    path: "seguimiento-solicitudes-referente",
    component: SeguimientoSolicitudesServicioComponent,
  },

  {
    path: "bandeja-programador",
    component: BandejaProgramadorComponent,
  },

  {
    path: "gestion-solicitud-programador/:id",
    component: GestionSolicitudProgramadorComponent
  },

  {
    path: "aprobacion-directivos",
    component: AprobacionServicioDirectivoComponent,
  },

  {
    path: "informes-solicitudes-servicio",
    component: InformesSolicitudesServicioComponent,
  },

  {
    path: "encuesta-satisfaccion/:id",
    component: EncuestaSatisfaccionComponent
  },

  { path: "**", component: AccesoComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
